import {ref, Ref} from 'vue';
export class EditorPanelSceneSelectorStoreControllerClass {
	private static _instance: EditorPanelSceneSelectorStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelSceneSelectorStoreControllerClass());
	}

	private constructor() {}

	private _displayed: Ref<boolean> = ref(false);

	// getters
	displayed(): boolean {
		return this._displayed.value;
	}

	// mutations
	open(): void {
		this._displayed.value = true;
	}
	close() {
		this._displayed.value = false;
	}
}

export const EditorPanelSceneSelectorStoreController = EditorPanelSceneSelectorStoreControllerClass.instance();
